import { APP_BASE_PATH } from '../../../../common/constants'
import { recommendedReadsData } from '../../consts'

const { howItWorks, whyWereBetter, testimonials } = recommendedReadsData
const TITLE = 'FAQs | Freedom Debt Relief'
const DESCRIPTION =
  'Browse our FAQs to learn about how Freedom Debt Relief works, debt relief fees, how to find a legit debt relief company, and more.'
const URL = `${APP_BASE_PATH()}/faq/`

export const faqData = {
  seo: {
    title: TITLE,
    description: DESCRIPTION,
    canonical: URL,
    openGraph: {
      title: TITLE,
      description: DESCRIPTION,
      url: URL,
      locale: 'en_US',
      type: 'article',
      article: {
        modifiedTime: '2020-05-12T17:01:10+00:00',
        authors: ['https://www.facebook.com/freedomdebtrelief'],
      },
      images: [
        {
          url: `${APP_BASE_PATH()}/next-assets/brand-pages/heros/faq.webp`,
        },
      ],
    },
  },
  heroData: {
    title: 'Frequently Asked Questions',
    description: {
      nodeType: 'paragraph',
      content: [
        {
          nodeType: 'text',
          value:
            'Find answers to commonly asked questions, so you can feel confident taking action to resolve your debt.',
          marks: [],
        },
      ],
    },
    phone: '800-910-0065',
    img: {
      src: '/next-assets/brand-pages/heros/faq.webp',
      alt: 'smiling Freedom Debt Relief customer service male representative',
    },
  },

  recommendedReads: [howItWorks, whyWereBetter, testimonials],

  bottomSectionData: {
    title: 'Don’t see an answer to your question? Reach out to us',
    list: ['No upfront fees', 'No loan required', 'No more doing it alone'],
    image: {
      src: '/next-assets/brand-pages/faq/section-cta-faq-img.webp',
      alt: 'happy female Freedom Debt Relief client',
    },
    isDark: false,
  },
}
